import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsUserRoleComponent extends Component {
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1'>
          <form.field @property='name' />
          <form.field @property='isAdmin' @type='checkbox' />
        </div>
        <div class='o-layout__item u-1/1'>
        </div>
      </div>
    </Form>
  </template>
}
